/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Einvoice_Credential_Howto_1Inputs */

const vi_einvoice_credential_howto_1 = /** @type {(inputs: Einvoice_Credential_Howto_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bước 1: nhập tài khoản meInvoice của chính bạn (số điện thoại hoặc email dùng để đăng nhập MISA).`)
};

/**

* @param {Einvoice_Credential_Howto_1Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const einvoice_credential_howto_1 = /** @type {((inputs?: Einvoice_Credential_Howto_1Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Einvoice_Credential_Howto_1Inputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_einvoice_credential_howto_1(inputs)
});